import {
  FeatureLevelPermissions,
  Permissions
} from '@/models/UserPermissions.model';

export interface Endpoint {
  name: string;
  url: string;
  method: 'GET' | 'POST' | 'PUT';
  permissions: Permissions[];
  bodyTemplate?: string;
}

export interface EndpointToolFormValues {
  endpoint: Endpoint;
  payload: string;
}

export const endpoints: Endpoint[] = [
  {
    bodyTemplate:
      '{\n' + '    "participantId": "",\n' + '    "planId": ""\n' + '}',
    method: 'POST',
    name: 'Add Participant',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/surpas/employee'
  },
  {
    bodyTemplate: '{\n' + '    "participantId": ""\n' + '}',
    method: 'PUT',
    name: 'Sync Participant',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/surpas/employee'
  },
  {
    bodyTemplate:
      '{\n' + '    "sponsorId": "",\n' + '    "isOnboarding": "false"\n' + '}',
    method: 'PUT',
    name: 'Sync Sponsor',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/surpas/employer'
  },
  {
    bodyTemplate: '{\n' + '    "payrollSetupId": "",\n' + '}',
    method: 'PUT',
    name: 'Sync Bank ccount',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/surpas/employer/bank-account'
  },
  {
    bodyTemplate:
      '{\n' +
      '    "fileNameExp": "MFC2_MASCIPEXT_CTRET_${today}.txt",\n' +
      '    "fileType": "cip"\n' +
      '}',
    method: 'POST',
    name: 'Ingest Surpas Employee file',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/surpas/ingestion/employee'
  },
  {
    bodyTemplate: '{\n' + '    "executionIds": []\n' + '}',
    method: 'POST',
    name: 'Retry Subaccounting Executions',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/subaccounting/execution/retry'
  },
  {
    method: 'GET',
    name: 'Test Get Participant Accounts',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_SHARED],
    url: '/endpoint-tool/participants/{participantId}/accounts'
  },
  {
    method: 'GET',
    name: 'Get Ingestion Activities',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/action-center/bulk/employer-list'
  },
  {
    bodyTemplate:
      '{\n' +
      '   "investmentOptions": [\n' +
      '     "targetSeries",\n' +
      '     "riskSeries",\n' +
      '     "goalSeries",\n' +
      '     "fundLineup",\n' +
      '     "401kManager",\n' +
      '     "tiaaNli"\n' +
      '   ],\n' +
      '   "newFund": "",\n' +
      '   "oldFund": "",\n' +
      '   "tradeDate": "YYYY-MM-DD"\n' +
      '}',
    method: 'POST',
    name: 'Create a Fund Change for a Program',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_BTC],
    url: '/endpoint-tool/investments/program/{programId}/fund-change'
  },
  {
    bodyTemplate: '{\n' + '   "programId": ,\n' + '   "sponsorPlanId": \n}',
    method: 'POST',
    name: 'Set participant to MS QDIA model',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_BTC],
    url: '/endpoint-tool/participants/{participantId}/retirement-planner/qdia'
  },
  {
    method: 'GET',
    name: 'Get Distribution STP Configuration',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/distribution-stp/config'
  },
  {
    method: 'PUT',
    name: 'Set Distribution STP Config Value',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/distribution-stp/config?key={key}&value={value}'
  },
  {
    bodyTemplate: '{\n' + '    "executionIds": []\n' + '}',
    method: 'POST',
    name: 'Cancel failed executions',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/subaccounting/cancel-execution'
  }
];
